// palette colours
const palette = {
  white: '#ffffff',
  black: '#000000',
  basis1: '#15202b',
  basis2: '#1f2a39',
  basis3: '#4a5c73',
  basis4: '#8B97A8',
  basis5: '#cbd1dd',
  basis6: '#dbe0ea',
  green: '#30dc83',
  blue: '#00abd9',
  orange: '#e27301',
  red: '#e20101',
  playUpGreen: '#01ca6e',
  primary: '#ff0056'
};

module.exports = {
  theme: {
    color: {
      lightBackground: '#e8ecf3',
      darkBackground: palette.basis1,
      background: palette.background,
      primary: palette.primary,
      secondary: palette.green,
      danger: palette.red,
      disabled: palette.basis4,
      warning: palette.orange,
      info: palette.blue,
      success: palette.green,
      panel: palette.basis6,
      panelAccent: palette.basis1,
      panelSelected: palette.primary,
      panelSecondary: palette.basis5,
      playUpGreen: palette.playUpGreen,
      widgetPrimary: palette.primary,
      widgetSecondary: palette.primary,
      white: palette.white,
      basis1: palette.basis1,
      basis2: palette.basis2,
      basis3: palette.basis3,
      basis4: palette.basis4,
      basis5: palette.basis5,
      basis6: palette.basis6,
      invertableBlack: palette.white,
      invertableWhite: palette.black,
      invertableBasis1: palette.basis6,
      invertableBasis2: palette.basis5,
      invertableBasis3: palette.basis4,
      invertableBasis4: palette.basis3,
      invertableBasis5: palette.basis2,
      invertableBasis6: palette.basis1,
      green: palette.green,
      orange: palette.orange,
      blue: palette.blue,
      enterButton: palette.blue,
      enteredButton: palette.green,
      sportsIcon: palette.primary
    }
  },
  skin: {
    PrizeLabel: {
      backgroundColor: palette.primary,
      color: palette.white
    },
    SalaryUtilisationBarProgress: {
      color1: palette.basis1,
      color2: palette.primary
    }
  }
};
